import React, { useEffect, useState } from "react";
import * as selector from '../../selectors/selectors';
import { useSelector } from 'react-redux';
import ButtonComponent from "../shared/button/button.component";
import { Checkbox, Dialog, DialogContent, TextField } from "@mui/material";
import { AiFileFailedIcon, AiFilePendingIcon, AiFileProcessingIcon, AiFileRemovingIcon, AiFileTrainedIcon, AiFileUploadingIcon, CancelIcon, ConversationBlackIcon, DocsBlackIcon, MediaDefaultIcon, MediaTxtIcon, NoTrainedLinksIcon, PdfIcon, RedRefreshIcon, SettingsBlackIcon, SettingsBlueIcon, UploadDocsIcon, UrlBlackIcon, WhiteRefreshIcon, WordIcon, XlsIcon, ZipIcon } from "../../icon";
import { MediaFileType } from "../../models/media.models";
import { FalkonAiService } from "../../services/FalkonAiService";
import { UserService } from "../../services/UserService";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";
import { setHeaderTitle } from "../../helpers/header.helper";
import { UtilityService } from "../../services/UtilityService";
import { useDispatch } from "react-redux";
import { updateAiTrainedFileList, updateAiTrainedUrlList, updateTrainChatHistoryStatus } from "../../reducers/reducer";
import LoaderComponent from "../shared/loaders/animate-loader.component";
import CrawlingWebsiteAnimation from "../shared/loaders/crawl-website-animation.json";
import Confirm_Dialog from "../shared/confirm-dialog.component";
import { pageTitles } from "../shared/constants";


enum UploadTypes {
    FILES = 0,
    URLS
}

enum TrainingStatus {
    Uploading = 'uploading',
    PENDING = 'pending',
    PROCESSING = 'processing',
    COMPLETED = 'completed',
    FAILED = 'failed',
    Removing = 'removing'
}


const FalkonAi: React.FC = () => {

    const dispatch = useDispatch();

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const TrainChatHistoryStatus: string = useSelector(selector.TrainChatHistoryStatus)
    const AiTrainedFiles: any[] = useSelector(selector.AiTrainedFiles)
    const AiTrainedUrls: any[] = useSelector(selector.AiTrainedUrls)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)

    const [start, setStart] = useState<boolean>(true);
    const [botName, setBotName] = useState<string>("");
    const [botDescription, setBotDescription] = useState<string>("");
    const [characterization, setCharacterization] = useState<string>("960 characters");
    const [outOfContextAnswer, setOutOfContextAnswer] = useState<string>("I am sorry, I do not have the answer to your question");
    const [feedType, setFeedType] = useState<number>(UploadTypes.FILES)
    const [files, setFiles] = useState<{ Name: string, Type: string, Status: string }[]>([])
    const [url, setUrl] = useState<string>("")
    const [urls, setUrls] = useState<{ Name: string, Status: any, Type: string }[]>([])
    const [urlCount, setUrlCount] = useState<"single" | "multiple">("single")
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [isRefreshLoading, setIsRefreshLoading] = useState<boolean>(false)
    const [isCrawlWebsiteLoading, setIsCrawlWebsiteLoading] = useState<boolean>(false)
    const [HoveringOption, sethoveringOption] = useState("")
    const [scrapedUrls, setScrapedUrls] = useState<{ Name: string, Selected: boolean }[]>([])
    const [chatHistoryDetails, setChatHistoryDetails] = useState({ LastUpdatedAt: "", Status: "" })
    const [baseUrl, setBaseUrl] = useState<string>("")
    const [animation, setAnimation] = useState<boolean>(false)
    const [openScrapedUrlsOpen, setOpenScrapedUrlsOpen] = useState<boolean>(false)
    const [urlAlreadyExistsError, setUrlAlreadyExistsError] = useState<string>("")
    const [file, setFile] = useState<any>({})
    const [confirmPopUp, setConfirmPopUp] = useState<{ show: boolean, datatype: "url" | "file" | "", data: any }>({ show: false, datatype: "", data: "" })

    const [ChatbotOptions, setChatbotOptions] = useState([
        { Name: "Upload Files", Selected: true },
        { Name: "Train URLs", Selected: false },
        // { Name: "Inbox Chat History", Selected: false },
        { Name: "Bot Settings", Selected: false },
    ])

    useEffect(() => {
        if (!!TrainChatHistoryStatus) {
            setChatHistoryDetails({ LastUpdatedAt: new Date().toLocaleString(), Status: TrainChatHistoryStatus.toLocaleLowerCase() })
        }
    }, [TrainChatHistoryStatus])

    useEffect(() => {
        setHeaderTitle(pageTitles.FALKON_AI)
    }, [])

    useEffect(() => {
        if (!!AiTrainedFiles.length) {
            setFiles(AiTrainedFiles.map((x) => {
                return (
                    { Name: x.file_name, Type: ".pdf", Status: x.status }
                )
            }
            ))
        }
        else {
            setFiles([])
        }
    }, [AiTrainedFiles])

    useEffect(() => {
        if (!!AiTrainedUrls.length) {
            setUrls(AiTrainedUrls.map(x => { return { Name: x.url, Status: x.status, Type: x.is_single_url ? "single" : "multiple" } }))
        }
        else {
            setUrls([])
        }
    }, [AiTrainedUrls])

    const getAllFiles = () => {
        FalkonAiService.getAllFiles(UserService.getCurrentUserOrgId()).then((res) => {
            if (res.data) {
                dispatch(updateAiTrainedFileList(res.data))
            }
        }).catch(() => {
            setFiles([])
        })
    }

    const getAllUrls = () => {
        FalkonAiService.getAllUrls(UserService.getCurrentUserOrgId()).then((res) => {
            if (res.data) {
                dispatch(updateAiTrainedUrlList(res.data))
            }
        }).catch((err) => {
            dispatch(updateAiTrainedUrlList([]))
            setUrls([])
        })
    }

    const handleOptionSelection = (option, feedType?) => {
        setChatbotOptions(ChatbotOptions.map(x => x.Name === option ? { ...x, Selected: true } : { ...x, Selected: false }))
        setFeedType(feedType)
    }

    const handleAddFiles = async (e: any) => {
        let file = (e?.target?.files[0] || e);
        if (file.size < 100 * 1024 * 1024) {
            if (file !== undefined) {
                if (file != null) {
                    if (file != null) {

                        let Files = [...files, {
                            Name: file.name,
                            Type: file.type,
                            Status: TrainingStatus.Uploading
                        }]

                        setFiles(Files)

                        var formData = new FormData();
                        formData.append("organization_id", UserService.getCurrentUserOrgId())
                        formData.append("file", file)

                        FalkonAiService.UploadFilesToAi(formData).then((res) => {

                            setFiles(Files.map((x) => x.Name === file.name ? { ...x, Status: TrainingStatus.PENDING } : x))
                            setFile({})
                            FalkonAiService.TrainUploadFilesToAi({ organization_id: UserService.getCurrentUserOrgId() }).then((res) => {

                                getAllFiles();

                            }).catch(() => {

                            })

                        }).catch((err) => {
                            setToast(err.response.data.error, ToasterType.DANGER, 5);
                            getAllFiles()
                            setFile({})
                        })
                    }
                }
            }
        }
    }

    const TrainFailedFile = (fileName) => {
        FalkonAiService.TrainFailedFileToAi({ organization_id: UserService.getCurrentUserOrgId(), file_name: fileName }).then(() => {
            getAllFiles();
        }).catch(() => {

        })
    }

    const handleRemoveFile = (fileName) => {
        setFiles(files.map(x => x.Name === fileName ? { ...x, Status: TrainingStatus.Removing } : x))
        setIsRefreshLoading(true)
        FalkonAiService.DeleteTrainedFileFromAi({ organization_id: UserService.getCurrentUserOrgId(), file_name: fileName }).then(() => {
            getAllFiles();
            setIsRefreshLoading(false)
            setConfirmPopUp({ show: false, datatype: "", data: "" })
        }).catch(() => {
        })
    }

    const handleConfirmDialog = (confirm: boolean) => {

        if (confirm) {
            if (confirmPopUp.datatype === "url") {
                handleRemoveUrl(confirmPopUp.data)
            }
            if (confirmPopUp.datatype === "file") {
                handleRemoveFile(confirmPopUp.data)
            }
        }
        else {
            setConfirmPopUp({ show: false, datatype: "", data: "" })
        }

    }

    const handleRemoveUrl = (url) => {
        setIsRefreshLoading(true)
        setUrls(urls.map(x => x.Name === url.Name ? { ...x, Status: TrainingStatus.Removing } : x))
        FalkonAiService.DeleteTrainedUrlsFromAi({ organization_id: UserService.getCurrentUserOrgId(), website_urls: [url.Name] }).then((res) => {
            getAllUrls();
            setIsRefreshLoading(false)
            setConfirmPopUp({ show: false, datatype: "", data: "" })
        }).catch(() => {

        })
    }

    const handleTrainUrls = (data: string[], scrapedLinks?: boolean) => {
        if (urlCount === "single" || scrapedLinks) {
            setIsLoading(true)
            FalkonAiService.TrainUrlsToAi({ organization_id: UserService.getCurrentUserOrgId(), urls: data, base_url: baseUrl }).then((res) => {
                dispatch(updateAiTrainedUrlList(res.data))
                setScrapedUrls([])
                setOpenScrapedUrlsOpen(false)
                setUrl("")
                setIsLoading(false)
            }).catch(() => {
                setUrl("")
                setIsLoading(false)
                setOpenScrapedUrlsOpen(false)
            })
        }
        else {
            setAnimation(true)
            setOpenScrapedUrlsOpen(true)
            FalkonAiService.WebsiteToCrawlandgetAllowedLinks({ organization_id: UserService.getCurrentUserOrgId(), website_url: data[0] }).then((res) => {
                setAnimation(false)
                setUrl("")
                if (!!res.data?.allowed_links) {
                    setScrapedUrls(res.data.allowed_links.map(x => { return ({ Name: x, Selected: false }) }))
                    setBaseUrl(res.data.base_domain)
                }
                else {
                    setToast("no links found for the given url", ToasterType.DANGER)
                    setOpenScrapedUrlsOpen(false)
                }
            }).catch(() => {
                setUrl("")
                setAnimation(false)
                setOpenScrapedUrlsOpen(false)
            })
        }
    }

    const handleSelectScrapedUrls = (url: { Name: string, Selected: boolean }) => {
        let selectedurls = scrapedUrls.map(x => x.Name === url.Name ? { ...x, Selected: !x.Selected } : x)
        if (selectedurls.map(x => x.Selected).length >= 5) {
            setScrapedUrls(scrapedUrls.map(x => x.Name === url.Name ? { ...x, Selected: !x.Selected } : { ...x, Selected: x.Selected ? true : false }))
        }
    }

    const handleTrainChatHistory = () => {
        setIsLoading(true)
        FalkonAiService.TrainChatHistoryToAi().then((res) => {
            setChatHistoryDetails({ LastUpdatedAt: new Date().toLocaleString(), Status: TrainingStatus.Uploading })
            setToast("Chat history training started", ToasterType.SUCCESS)
            setIsLoading(false)
        }).catch((err) => {
            setToast(err.data, ToasterType.DANGER)
            setIsLoading(false)
        })
    }

    const handleDeleteChatHistory = () => {
        setChatHistoryDetails({ ...chatHistoryDetails, Status: TrainingStatus.Removing })
        FalkonAiService.DeleteChatHistoryFromAi({ organization_id: UserService.getCurrentUserOrgId() }).then((res) => {
            setToast(res.data.message, ToasterType.SUCCESS)
            dispatch(updateTrainChatHistoryStatus(""))
            setChatHistoryDetails({ LastUpdatedAt: "", Status: "" })
        }).catch(() => {

        })
    }

    const getTrainedChatHistoryDetails = () => {
        FalkonAiService.getChatHistoryDetails(UserService.getCurrentUserOrgId()).then((res) => {
            setChatHistoryDetails({ LastUpdatedAt: res.data.updated_at, Status: res.data.status })
        }).catch(() => {
        })
    }

    const handleUrlOnChange = (e) => {
        setUrl(e.target.value)
        if (urls.find(x => x.Name === e.target.value.trim()) && urlCount === "single") {
            setUrlAlreadyExistsError("url already trained")
        }
        else {
            setUrlAlreadyExistsError("")
        }
    }

    const handleUrlTrainType = (type: "single" | "multiple") => {
        setUrlCount(type);
        setUrl("");
        setIsLoading(false);
        setUrlAlreadyExistsError("")
    }

    const getMediaTypeIcon = (type: any, size?: string) => {
        if (type != null) {
            switch (type) {
                case MediaFileType.PDF:
                    return <PdfIcon className={size} />
                case MediaFileType.ZIP:
                    return <ZipIcon className={size} />
                case MediaFileType.DOC:
                    return <WordIcon className={size} />
                case MediaFileType.DOCX:
                    return <WordIcon className={size} />
                case MediaFileType.XLSX:
                    return <XlsIcon className={size} />
                case MediaFileType.TXT:
                    return <MediaTxtIcon className={size} />
                default:
                    return <MediaDefaultIcon className={size} />
            }
        }
    };


    return (
        <>
            <div className={`w-p-100 h-p-100  d-flex justify-center align-center ${IsDarkMode ? "bg-color-sidebar-bg" : "bg-color-grid"}`}>
                <div className="w-p-97 h-p-95 br-2 d-flex flex-direction justify-center align-center">
                    <div className={`w-p-100 h-p-100 ${IsDarkMode ? "bg-color-primary-background" : "bg-color-secondary"}  br-2 d-flex flex-direction`}>
                        <div className="w-p-90 d-flex justify-between align-center mx-auto">
                            <div className="d-flex mt-2 mb-1">
                                <div className={`mr-2 ${ChatbotOptions.find(x => x.Selected).Name === "Upload Files" ? "falkon-ai-option-active" : "falkon-ai-option-disabled"} ${IsDarkMode ? "color-secondary" : "color-primary-accent"} h4-medium c-pointer d-flex align-center justify-center h-5 px-2`} onClick={() => { handleOptionSelection("Upload Files", UploadTypes.FILES) }}>
                                    <DocsBlackIcon className="w-3 mr-1" />
                                    Files
                                    {!!files.length && <div className={`w-3 h-3 br-3 h6-medium d-flex align-center justify-center ml-2 bg-color-ai-files-urls-count ${IsDarkMode ? "color-primary-accent" : "color-secondary"}`}>{files.length}</div>}
                                </div>
                                <div className={`mr-2 ${ChatbotOptions.find(x => x.Selected).Name === "Train URLs" ? "falkon-ai-option-active" : "falkon-ai-option-disabled"} ${IsDarkMode ? "color-secondary" : "color-primary-accent"} h4-medium c-pointer d-flex align-center justify-center h-5 px-2`} onClick={() => { handleOptionSelection("Train URLs", UploadTypes.URLS) }}>
                                    <UrlBlackIcon className="w-3 mr-1" />
                                    URLs
                                    {!!urls.length && <div className={`w-3 h-3 br-3 h6-medium d-flex align-center justify-center ml-2 bg-color-ai-files-urls-count ${IsDarkMode ? "color-primary-accent" : "color-secondary"}`}>{urls.length}</div>}
                                </div>
                                {/* <div className={`mr-2 ${ChatbotOptions.find(x => x.Selected).Name === "Inbox Chat History" ? "falkon-ai-option-active" : "falkon-ai-option-disabled"} color-primary-accent h4-medium c-pointer d-flex align-center justify-center h-5 px-2`} onClick={() => { handleOptionSelection("Inbox Chat History") }}>
                                    <ConversationBlackIcon className="w-3 mr-1" />
                                    Inbox (chat history)
                                </div> */}
                            </div>
                            <div className={`d-flex mt-2 mb-1 h4-medium ${(ChatbotOptions.find(x => x.Selected).Name === "Bot Settings" || HoveringOption === "Bot Settings") ? "color-primary-light" : "color-primary-accent"}`}>
                                <div className="my-auto c-pointer d-flex align-center" onClick={() => handleOptionSelection("Bot Settings")} onMouseEnter={() => { sethoveringOption("Bot Settings") }} onMouseLeave={() => { sethoveringOption("") }}>
                                    {(HoveringOption === "Bot Settings" || ChatbotOptions.find(x => x.Selected).Name === "Bot Settings") ? <SettingsBlueIcon className="w-3 mr-1" /> : <SettingsBlackIcon className="w-3 mr-1" />}
                                    Bot Settings
                                </div>
                            </div>
                        </div >
                        <div className="d-flex flex-direction align-center py-2 w-p-100 o-y-scroll">
                            <div className="w-p-90 h-4 h2-semibold d-flex align-center mx-auto">
                                {ChatbotOptions.find(x => x.Selected).Name}
                            </div>
                            {
                                ChatbotOptions.find(x => x.Selected).Name === "Bot Settings" ?
                                    <>
                                        <div className="w-p-90 h-4 d-flex justify-between mx-auto settings-header-divider">
                                            <div className="h5-regular">Your Bot settings</div>
                                        </div>
                                        <div className="w-p-90 d-flex flex-direction mx-auto mt-2">
                                            <div className='w-p-100 min-h-4 d-flex justify-between align-center'>
                                                <div className="h5-medium">Response Customization</div>
                                            </div>
                                            <div className='w-p-100 d-flex justify-between align-center color-settings-nav-bar-option'>
                                                <div className="h5-regular">Length of the falkon ai replies.</div>
                                            </div>
                                            <div className='w-p-100min-h-6 d-flex justify-between align-center mb-2'>
                                                <TextField
                                                    value={characterization}
                                                    className="w-p-100 h4-regular mt-1"
                                                    size="small"
                                                    variant="outlined"
                                                    label="Character count"
                                                    disabled
                                                    onChange={(e) => setCharacterization(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-p-90 d-flex flex-direction mx-auto">
                                            <div className='w-p-100 min-h-4 d-flex justify-between align-center'>
                                                <div className="h5-medium">Fallback Response Settings</div>
                                            </div>
                                            <div className='w-p-100 d-flex justify-between align-center color-settings-nav-bar-option'>
                                                <div className="h5-regular">Define how the chatbot should respond when a query is out of context or not covered by the provided documents.</div>
                                            </div>
                                            <div className='w-p-100 min-h-6 d-flex justify-between align-center mb-2'>
                                                <TextField
                                                    value={outOfContextAnswer}
                                                    className="w-p-100 h4-regular mt-1"
                                                    size="small"
                                                    variant="outlined"
                                                    label="Out of Context Answer"
                                                    disabled
                                                    onChange={(e) => setOutOfContextAnswer(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="w-p-90 d-flex flex-direction mx-auto">
                                            <div className='w-p-100 min-h-4 d-flex justify-between align-center'>
                                                <div className="h5-medium">Suggestion Features</div>
                                            </div>
                                            <div className='w-p-100 d-flex justify-between align-center color-settings-nav-bar-option'>
                                                <div className="h5-regular">Length of the conversations to feed ai for suggestion message</div>
                                            </div>
                                            <div className='w-p-100min-h-6 d-flex justify-between align-center mb-2'>
                                                <TextField
                                                    value={5}
                                                    className="w-p-100 h4-regular mt-1"
                                                    size="small"
                                                    variant="outlined"
                                                    label="Conversation count"
                                                    disabled
                                                    onChange={(e) => setCharacterization(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        {/* <div className="w-p-90 mx-auto mt-2">
                                            <ButtonComponent ClassName="ml-auto px-5" ButtonLabel={"Save"} Variant={"primary-btn"} />
                                        </div> */}
                                    </>
                                    :
                                    ChatbotOptions.find(x => x.Selected).Name === "Inbox Chat History" ?
                                        <>
                                            <div className="w-p-90 d-flex justify-between mx-auto settings-header-divider align-center">
                                                <div className="">
                                                    <div className="h5-medium color-settings-heading">
                                                        Give access to all conversations from your customer history,
                                                    </div>
                                                    <div className="h5-medium color-settings-heading">
                                                        helping the AI Bot provide more relevant and informed responses.
                                                    </div>
                                                </div>
                                                <ButtonComponent Variant="primary-btn" ButtonLabel={"Train Conversations"} Loading={isLoading} OnClick={handleTrainChatHistory} />
                                            </div>
                                            <div className="w-p-100 mt-2">
                                                <div className="w-p-90 min-h-6 h4-medium d-flex mx-auto bg-color-grid upload-files-border">
                                                    <div className="d-flex align-center ml-2">
                                                        Last updated at
                                                    </div>
                                                </div>
                                                <div className="w-p-90 min-h-6 h5-medium d-flex align-center mx-auto upload-files-border">
                                                    <div className="d-flex align-center ml-2 w-p-70">
                                                        {chatHistoryDetails.LastUpdatedAt ? UtilityService.convertToDateTimeFormat(chatHistoryDetails.LastUpdatedAt) : "---"}
                                                    </div>
                                                    <div className="ml-auto mr-2 w-p-20">
                                                        {
                                                            chatHistoryDetails.Status === TrainingStatus.Uploading ?
                                                                <AiFileUploadingIcon />
                                                                : chatHistoryDetails.Status === TrainingStatus.Removing ?
                                                                    <AiFileRemovingIcon />
                                                                    : chatHistoryDetails.Status === TrainingStatus.PENDING ?
                                                                        <AiFilePendingIcon />
                                                                        : chatHistoryDetails.Status === TrainingStatus.PROCESSING ?
                                                                            <AiFileProcessingIcon />
                                                                            : chatHistoryDetails.Status === TrainingStatus.FAILED ?
                                                                                <div className="color-primary-danger d-flex align-center">
                                                                                    <AiFileFailedIcon />
                                                                                    <RedRefreshIcon className="ml-1 w-2 h-2 c-pointer" onClick={() => { handleTrainChatHistory() }} />
                                                                                </div>
                                                                                :
                                                                                chatHistoryDetails.Status === TrainingStatus.COMPLETED &&
                                                                                <AiFileTrainedIcon />
                                                        }
                                                    </div>
                                                    <div className="w-2 ml-auto mr-2 d-flex align-center">
                                                        {(chatHistoryDetails.Status === TrainingStatus.COMPLETED || chatHistoryDetails.Status === TrainingStatus.FAILED) && <CancelIcon className="w-2 c-pointer" onClick={() => handleDeleteChatHistory()} />}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <>

                                            {
                                                feedType === UploadTypes.FILES ?
                                                    <>
                                                        <div className="w-p-90 d-flex justify-between mx-auto settings-header-divider">
                                                            <div className="h5-medium color-settings-heading">The files will be used by the Falkon AI to determine whether it needs to use related documents to answer customer questions. Therefore, the better the description you provide, the easier it will be for the Falkon AI to respond to customer inquiries.</div>
                                                        </div>
                                                        <div className="w-p-90 d-flex justify-center align-center min-h-24 upload-files-dashed-border mb-4 mt-1"
                                                            onDrop={(event) => {
                                                                event.preventDefault()
                                                                const file = event.dataTransfer.files[0]
                                                                if (file !== null) {
                                                                    handleAddFiles(file);
                                                                }
                                                            }}
                                                            onDragOverCapture={(event) => {
                                                                event.preventDefault();
                                                            }}
                                                            onDragLeave={(event) => { }}>
                                                            <input
                                                                color="primary"
                                                                accept={`.pdf`}
                                                                type="file"
                                                                onChange={(event) => {
                                                                    handleAddFiles(event);
                                                                    event.target.value = "";
                                                                }}
                                                                id={"icon-button-file"}
                                                                style={{ display: 'none' }}
                                                            />
                                                            <label htmlFor={"icon-button-file"} className="d-flex flex-direction align-center w-p-100 my-5">
                                                                <div className="br-50 d-flex align-center justify-center"><UploadDocsIcon className="w-20" /></div>
                                                                <div className="h5-medium py-1 c-pointer">Click here to browse files or Drag and drop files</div>
                                                                <div className="footnote-medium color-live-chat-anonymous">File Types: .pdf</div>
                                                                <div className="footnote-medium color-live-chat-anonymous">Only up to 100 MB</div>
                                                            </label>
                                                        </div>

                                                        <div className="w-p-100">
                                                            {!!files?.length &&
                                                                <div className={`w-p-90 min-h-6 h4-medium d-flex mx-auto  upload-files-border ${IsDarkMode ? "bg-color-primary-background" : "bg-color-grid"}`}>
                                                                    <div className="d-flex align-center ml-2">
                                                                        Files
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                files &&
                                                                <div className="w-p-100 mx-auto">
                                                                    {files.map(x => {
                                                                        return (
                                                                            <div className="w-p-90 min-h-6 h5-medium d-flex align-center mx-auto upload-files-border">
                                                                                <div className="d-flex align-center ml-2 w-p-70">
                                                                                    {getMediaTypeIcon(x.Type.includes("application") ? x.Name.split('.')[x.Name.split('.')?.length - 1] : x.Type.split('/')[0], "w-2 h-2 mr-2")}
                                                                                    {x.Name}
                                                                                </div>
                                                                                <div className="ml-auto mr-2 w-p-20">
                                                                                    {
                                                                                        x.Status === TrainingStatus.Uploading ?
                                                                                            <AiFileUploadingIcon />
                                                                                            : x.Status === TrainingStatus.Removing ?
                                                                                                <AiFileRemovingIcon />
                                                                                                : x.Status === TrainingStatus.PENDING ?
                                                                                                    <AiFilePendingIcon />
                                                                                                    : x.Status === TrainingStatus.PROCESSING ?
                                                                                                        <AiFileProcessingIcon />
                                                                                                        : x.Status === TrainingStatus.FAILED ?
                                                                                                            <div className="color-primary-danger d-flex align-center">
                                                                                                                <AiFileFailedIcon />
                                                                                                                <RedRefreshIcon className="ml-1 w-2 h-2 c-pointer" onClick={() => { TrainFailedFile(x.Name) }} />
                                                                                                            </div>
                                                                                                            :
                                                                                                            x.Status === TrainingStatus.COMPLETED &&
                                                                                                            <AiFileTrainedIcon />
                                                                                    }
                                                                                </div>
                                                                                <div className="w-2 ml-auto mr-2 d-flex align-center">
                                                                                    {(x.Status === TrainingStatus.COMPLETED || x.Status === TrainingStatus.FAILED) && <CancelIcon className="w-2 c-pointer" onClick={() => { setConfirmPopUp({ show: true, datatype: "file", data: x.Name }) }} />}
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                    </>

                                                    :
                                                    <>
                                                        <div className="w-p-90 d-flex justify-between mx-auto settings-header-divider">
                                                            <div className="h5-medium color-settings-heading">
                                                                Train Falkon AI on your website content so it can provide accurate, relevant reply suggestions.
                                                            </div>
                                                        </div>
                                                        <div className={`w-p-90 h4-medium d-flex mx-auto ${IsDarkMode ? "bg-color-primary-background" : "bg-color-grid"} upload-files-border flex-direction mt-1`}>
                                                            <div className="w-p-100 d-flex align-center">
                                                                <div className={`w-p-50 h3-semibold d-flex align-center justify-center ${urlCount === "single" ? "color-primary-light ai-active-border-bottom" : "color-primary-accent ai-disabled-border-bottom"} c-pointer pt-2 pb-1`} onClick={() => { handleUrlTrainType("single") }}>
                                                                    Single URL training
                                                                </div>
                                                                <div className={`w-p-50 h3-semibold d-flex align-center justify-center ${urlCount === "multiple" ? "color-primary-light ai-active-border-bottom" : "color-primary-accent ai-disabled-border-bottom"} c-pointer pt-2 pb-1`} onClick={() => { handleUrlTrainType("multiple") }}>
                                                                    Multiple URL training
                                                                </div>
                                                            </div>
                                                            <div className="w-p-90 d-flex align-center h5-medium mt-1 mx-auto">
                                                                {urlCount === "single" ? "Enter a link, and the chatbot will use the page content to answer questions accurately"
                                                                    :
                                                                    "Enter a domain name, then we'll find pages for you to choose from (select up to 5 pages)"}
                                                            </div>
                                                            <div className="w-p-90 mx-auto h-p-50 d-flex align-center mb-1">
                                                                <TextField
                                                                    value={url}
                                                                    className="w-p-80 h4-regular flex-1 mr-2 bg-color-secondary"
                                                                    size="small"
                                                                    variant="outlined"
                                                                    placeholder="www.example.com"
                                                                    onChange={(e) => handleUrlOnChange(e)}
                                                                />
                                                                <ButtonComponent ButtonLabel={urlCount === "single" ? "Train" : "Crawl Website"} Loading={isLoading} Variant={(url.length && !urlAlreadyExistsError.length) ? "primary-btn" : "disabled-btn"} OnClick={() => { handleTrainUrls([url]) }} ClassName="ml-auto min-h-5" />
                                                            </div>
                                                            {
                                                                !!urlAlreadyExistsError.length &&
                                                                <div className="w-p-90 mx-auto d-flex align-center mb-1 color-primary-danger h5-medium">
                                                                    {urlAlreadyExistsError}
                                                                </div>
                                                            }
                                                        </div>
                                                        {!!urls.length ?
                                                            <div className="w-p-100 mt-2">
                                                                <div className={`w-p-90 min-h-6 h4-medium d-flex mx-auto ${IsDarkMode ? "bg-color-primary-background" : "bg-color-grid"} upload-files-border`}>
                                                                    <div className="d-flex align-center ml-2 w-p-20">
                                                                        Type
                                                                    </div>
                                                                    <div className="d-flex align-center w-p-60">
                                                                        Name
                                                                    </div>
                                                                </div>
                                                                <div className="w-p-100 mx-auto">
                                                                    {urls.map(x => {
                                                                        return (
                                                                            <div className="w-p-90 min-h-6 h5-medium d-flex align-center mx-auto upload-files-border">
                                                                                <div className="d-flex align-center ml-2 w-p-20">
                                                                                    {x.Type}
                                                                                </div>
                                                                                <div className="d-flex align-center w-p-60">
                                                                                    {x.Name}
                                                                                </div>
                                                                                <div className="d-flex align-center w-p-20">
                                                                                    {
                                                                                        x.Status.toLowerCase() === TrainingStatus.Uploading ?
                                                                                            <AiFileUploadingIcon />
                                                                                            : x.Status.toLowerCase() === TrainingStatus.Removing ?
                                                                                                <AiFileRemovingIcon />
                                                                                                : x.Status.toLowerCase() === TrainingStatus.PENDING ?
                                                                                                    <AiFilePendingIcon />
                                                                                                    : x.Status.toLowerCase() === TrainingStatus.PROCESSING ?
                                                                                                        <AiFileProcessingIcon />
                                                                                                        : x.Status.toLowerCase() === TrainingStatus.FAILED ?
                                                                                                            <div className="color-primary-danger d-flex align-center">
                                                                                                                <AiFileFailedIcon />
                                                                                                            </div>
                                                                                                            :
                                                                                                            x.Status.toLowerCase() === TrainingStatus.COMPLETED &&
                                                                                                            <AiFileTrainedIcon />
                                                                                    }
                                                                                </div>
                                                                                <div className="w-2 ml-auto mr-2 d-flex align-center">
                                                                                    {(x.Status.toLowerCase() === TrainingStatus.COMPLETED || x.Status.toLowerCase() === TrainingStatus.FAILED) && <CancelIcon className="w-2 c-pointer" onClick={() => setConfirmPopUp({ show: true, datatype: "url", data: x })} />}
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                    }
                                                                </div>
                                                            </div>
                                                            :
                                                            <div className="w-p-100 mt-2 d-flex flex-direction align-center">
                                                                <NoTrainedLinksIcon className="mx-auto mt-4" />
                                                                <div className="d-flex justify-center align-center mt-2 h4-medium">
                                                                    Get started by entering your URLs
                                                                </div>
                                                            </div>
                                                        }
                                                    </>
                                            }
                                        </>
                            }

                        </div>
                    </div >
                </div >
            </div >
            {openScrapedUrlsOpen &&
                <Dialog
                    fullWidth
                    onClose={() => { setScrapedUrls([]); setBaseUrl(""); setOpenScrapedUrlsOpen(false); setAnimation(false) }}
                    open={openScrapedUrlsOpen}
                    BackdropProps={{ style: { backgroundColor: "transparent" } }}
                    classes={{ paper: "w-p-70 p-0 m-0 br-0 dialogue-shadow" }}
                >
                    <DialogContent className="m-0 p-0 br-0">
                        {animation ?
                            <div className="w-p-100 mx-auto h5-medium pt-2 pb-4">
                                <div className="d-flex justify-center align-center mx-auto">
                                    <CancelIcon className="ml-auto pr-2 my-auto c-pointer" onClick={() => { setScrapedUrls([]); setBaseUrl(""); setOpenScrapedUrlsOpen(false); setAnimation(false) }} />
                                </div>
                                <LoaderComponent LoaderAnimation={CrawlingWebsiteAnimation} />
                                <div className="d-flex justify-center align-center mx-auto">
                                    Scanning links… this may take up to 2 minutes.
                                </div>
                                <div className="d-flex justify-center align-center mx-auto">
                                    Please don’t close this tab during the process.
                                </div>
                            </div>
                            :
                            <div className="w-p-100 mx-auto">
                                <div className=" min-h-7 h5-semibold d-flex mx-auto bg-color-nav-bar upload-files-border">
                                    <div className="d-flex align-center pl-4">
                                        {`Selected (${scrapedUrls.filter(x => x.Selected).length}/5)`}
                                    </div>
                                    <CancelIcon className="ml-auto pr-2 my-auto c-pointer" onClick={() => { setScrapedUrls([]); setBaseUrl(""); setOpenScrapedUrlsOpen(false) }} />
                                </div>
                                <div className="w-p-100 o-y-scroll max-h-60">
                                    {scrapedUrls.filter(x => !!x.Name).map(x => {
                                        return (
                                            <div className="w-p-100">
                                                <div className="min-h-6 h5-medium d-flex align-center mx-auto">
                                                    <Checkbox
                                                        name="checkbox"
                                                        onChange={() => { handleSelectScrapedUrls(x) }}
                                                        classes={{ checked: "selected-checkbox", disabled: "disabled-checkbox" }}
                                                        checked={x.Selected}
                                                        className="ml-2"
                                                        size="medium"
                                                        disabled={(scrapedUrls.filter(x => x.Selected).length >= 5 && !x.Selected || urls.map(y => y.Name).includes(x.Name))}
                                                    />
                                                    <div className={`d-flex align-center ml-2 ${urls.map(y => y.Name).includes(x.Name) && "color-disabled-btn-unauth"}`}>
                                                        {x.Name}
                                                    </div>
                                                </div>
                                                <hr className="unsubscribe-hr opacity-1 m-0 p-0"></hr>
                                            </div>
                                        )
                                    })
                                    }
                                </div>
                                <div className="w-p-100 d-flex justify-center my-2">
                                    <ButtonComponent ButtonLabel={"Train"} Variant={scrapedUrls.find(x => x.Selected) ? "primary-btn" : "disabled-btn"} Loading={isLoading} ClassName="h4-medium px-4 py-1" OnClick={() => { handleTrainUrls(scrapedUrls.filter(x => x.Selected).map(x => x.Name), true); }} />
                                </div>
                            </div>
                        }
                    </DialogContent>
                </Dialog>
            }
            {
                confirmPopUp.show &&
                <Confirm_Dialog Loading={isRefreshLoading} Show={confirmPopUp.show} onClose={handleConfirmDialog} ButtonName="Unlearn" Text="Do you want to remove this source and unlearn its contents from the Falkon AI's knowledge?" Title="Unlearn this source?" />
            }
        </>
    )

}

export default FalkonAi;